import React, { useEffect, useState } from "react";
import moment from 'moment';

export default ({ time = moment().unix(), onTimeOut = () => { } }) => {

    const [countDown, setCountDown] = useState(time - moment().unix());

    useEffect(() => {
        let interval;
        if (time - moment().unix() > 0) {
            interval = setInterval(() => {
                const _countDown = time - moment().unix();
                setCountDown(_countDown);
                if (_countDown < 1) {
                    onTimeOut();
                    clearInterval(interval);
                }
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [time])

    if (countDown < 1) return null;

    return <span style={{ width: "5rem" }}>{moment.utc(countDown * 1000).format('HH:mm:ss')}</span>
}